import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/excel";

const analyzeExcel = async ({ schoolYearId, file }) => {
  const formData = new FormData();

  formData.append("schoolYearId", schoolYearId);
  formData.append("file", file);

  const response = await api.post(`${BASE_URL}/analyze`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const importExcel = async ({
  schoolYearId,
  file,
  autoCreateFields,
  existingDossierMode,
}) => {
  const formData = new FormData();

  formData.append("schoolYearId", schoolYearId);
  formData.append("file", file);
  formData.append("autoCreateFields", String(autoCreateFields));
  formData.append("existingDossierMode", existingDossierMode);

  const response = await api.post(`${BASE_URL}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const excelService = {
  analyzeExcel,
  importExcel,
};

export default excelService;
